/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * TaintEffect is a node taint effect.
 * @export
 * @enum {string}
 */

export const NodetemplatesV1TaintEffect = {
    NoSchedule: 'NoSchedule',
    NoExecute: 'NoExecute'
} as const;

export type NodetemplatesV1TaintEffect = typeof NodetemplatesV1TaintEffect[keyof typeof NodetemplatesV1TaintEffect];



